import reducer from './rootReducer'
import { combineReducers } from 'redux'

export default combineReducers({reducer})